
import { ServiceData } from '@/types/serviceTypes';

export const lawnMaintenanceService: ServiceData = {
  title: 'Lawn Maintenance',
  description: 'Comprehensive lawn care services to keep your grass healthy and vibrant year-round.',
  longDescription: [
    'Our professional lawn maintenance services are designed to keep your property looking its best throughout the growing season. We take a holistic approach to lawn care, focusing not just on regular mowing but on the overall health and appearance of your turf.',
    'Our trained technicians evaluate your lawn\'s specific needs and develop a customized maintenance plan. From proper mowing height and frequency to edge trimming and debris removal, we handle every detail with care and precision.',
    'Regular lawn maintenance not only enhances your property\'s curb appeal but also promotes healthier grass that\'s more resistant to weeds, pests, and environmental stresses. Let PK Landscape Associates take the hassle out of lawn care so you can enjoy your beautiful outdoor space.'
  ],
  image: '/lovable-uploads/b541e3ea-3486-4882-934b-2e604eba9aae.png',
  features: [
    'Weekly or bi-weekly mowing schedules',
    'Precision edge trimming along walkways and beds',
    'Blowing and cleanup of clippings and debris',
    'String trimming around obstacles and tight spaces',
    'Seasonal adjustments to mowing heights'
  ],
  benefits: [
    'Enhanced curb appeal and property value',
    'Healthier turf with fewer weeds and bare spots',
    'Consistent professional appearance',
    'More time to enjoy your outdoor space',
    'Prevention of common lawn problems'
  ],
  process: [
    {
      title: 'Initial Assessment',
      description: 'We evaluate your lawn\'s condition, grass type, sun exposure, and specific challenges.'
    },
    {
      title: 'Customized Plan',
      description: 'Based on the assessment, we create a maintenance schedule tailored to your lawn\'s needs.'
    },
    {
      title: 'Regular Service',
      description: 'Our trained technicians perform scheduled maintenance following best practices.'
    },
    {
      title: 'Ongoing Monitoring',
      description: 'We continuously assess your lawn\'s health and adjust our approach as needed.'
    }
  ],
  relatedServices: [
    { id: 'fertilization', title: 'Fertilization' },
    { id: 'spring-fall-cleanups', title: 'Spring/Fall Clean Ups' },
    { id: 'irrigation', title: 'Irrigation' }
  ]
};
